import React from 'react';
import InvoiceForm from '../../Components/InvoiceForm'

function CreateInvoice(props) {
	return (
		<div>
			<div>
				<h1>Create Invoice</h1>
			</div>
			<InvoiceForm />
		</div>
	);
}

export default CreateInvoice;